import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MuiTableRow from '@material-ui/core/TableRow';
import styled from 'src/ui/library/styled';

const styles = theme => ({
  root: {},
  bodyRow: {
    cursor: 'pointer',
    //boxShadow: '0 0 4px 0 rgba(0,0,0,0.03)'
  },
  headerRow: {},
  evenRow: {
    backgroundColor: 'rgba(246,246,250,0.5)',
  },
});

class TableRow extends React.Component {
  static propTypes = {
    /** Styles to be applied to component */
    classes: PropTypes.object,
  };

  static defaultProps = {
    rowType: 'body',
  };

  render() {
    const { classes, children, onClick, rowType, rowIndex } = this.props;
    const rowClass = classNames({
      // eventually we'll move all this internal styling to SCSS
      [classes.root]: true,
      [classes.bodyRow]: rowType === 'body',
      [classes.headerRow]: rowType === 'head',
      [classes.oddRow]: rowIndex % 2 !== 0,
      [classes.evenRow]: rowIndex % 2 === 0,
      'body-row': rowType === 'body',
      'header-row': rowType === 'head',
      'odd-row': rowIndex % 2 !== 0,
      'even-row': rowIndex % 2 === 0,
    });

    return (
      <MuiTableRow className={rowClass} onClick={onClick}>
        {children}
      </MuiTableRow>
    );
  }
}

export default styled(TableRow)(styles);
